import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { DataConfirm } from './DataConfirm';

interface Amplia {
  checkedAgregar: boolean;
  setAmplia: React.Dispatch<React.SetStateAction<boolean>>;
  setCheckedAgregar: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ConfirmAmplia: React.FC<Amplia> = ({
  setAmplia,
  checkedAgregar,
  setCheckedAgregar,
}) => {
  const [check, setCheck] = useState(false);
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));


  const handleChangeAgregar = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setCheckedAgregar(event.target.checked);
  };

  const handleClick = () => {
    setCheck((check) => !check);
  };

 

  useEffect(() => {
    checkedAgregar ? setAmplia(true) : setAmplia(false);
  }, [checkedAgregar, setAmplia]);

  return (
    <Box sx={{ margin: '15px 0px' }}>
      <Typography
        sx={{
          fontFamily: 'Montserrat',
          fontSize: isMobile ? '18px' : '20px',
          fontWeight: 600,
          textAlign: 'center',
          color: '#212121',
        }}
      >
        {'¿Quieres protección adicional?'}
      </Typography>
      <Grid
        item
        xs={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Checkbox
          sx={{
            '&:hover': { bgcolor: 'transparent' },
            color: '#c7c7c7',
          }}
          name="agregar"
          checked={checkedAgregar}
          onChange={handleChangeAgregar}
          inputProps={{ 'aria-label': 'controlled' }}
        />
        <Typography
          sx={{
            color: '#000000',
            fontSize: isMobile ? '16px' : '20px',
            fontWeight: 400,
          }}
        >
          {'Protección Plus'}
        </Typography>
        <Button sx={{ position: 'absolute', right: 11 }} onClick={handleClick}>
          <ExpandMore style={{ color: '#039ECC' }} />
        </Button>
      </Grid>
      <Divider
        color="#C7C7C7"
        sx={{ height: 1, width: '95%', margin: '10px auto 20px auto' }}
      />
      {check ? <DataConfirm /> : null}
    </Box>
  );
};
